import React from "react";

export const Iconi = ({}) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="#6f8aa5" rx="3" />
      <text
        x="10"
        y="14"
        font-size="14"
        text-anchor="middle"
        fill="#FFFFFF"
        font-family="Arial"
      >
        i
      </text>
    </svg>
  );
};
